export default __webpack_public_path__ + "static/media/Amount-schedule.188107db.svg";